<template>
  <div v-if="availableServices.length < 1">
    Loading 6xx services
  </div>
  <v-chip v-else
          :color="color"
          @click="handleClick">6XX
  </v-chip>
</template>

<script>

    import {mapActions, mapState} from "vuex";

    export default {
        name: 'filter-6xx',
        components: {},
        props: {
            value: {
                type: Array,
            },
        },
        data() {
            return {}
        },
        mounted() {
            this.fetchInitDataIfRequired()
        },
        computed: {
            ...mapState({
                availableServices: 'availableServices'
            }),
            services6xx() {
                return _.filter(this.availableServices, s => s.code >= 600 && s.code < 700)
                    .map(s => s.id)
            },
            services6xxSelected() {
                return _.intersection(this.value, this.services6xx).length === this.services6xx.length
            },
            color() {
                if (this.services6xxSelected) {
                    return 'primary'
                } else {
                    return ''
                }
            }
        },
        methods: {
            ...mapActions({
                fetchInitDataIfRequired: 'fetchInitDataIfRequired'
            }),
            handleClick() {
                if (this.services6xxSelected) {
                    this.$emit("input", [])
                } else {
                    this.$emit("input", this.services6xx)
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/analytics/Filter6xx.vue